import React, { useEffect, useState } from "react";
import jsCookie from 'js-cookie';
import {
  CheckCircleIcon,
  AlertTriangleIcon,
  CheckCircle2,
  CheckCircle2Icon,
  CheckCheckIcon,
} from "lucide-react";
import SwitchIcon from "src/assets/images/switch.svg";
import BookIcon from "src/assets/images/book.svg";
import { useAppDispatch } from "src/hooks/redux";
import { anaylzeChatBotChecklist } from "./action";
import DotLoader from "src/components/reusable/dot-loader";

interface ChecklistItem {
  message: string;
  status: "success" | "warning";
}

const checklistData: ChecklistItem[] = [
  {
    message: "Core Join Keys Detected: user_id, account_id, timestamp",
    status: "success",
  },
  {
    message: "Seat Data Aligned: licensed_seats + active_seats found across 90% of rows",
    status: "success",
  },
  {
    message: "Missing Fields: 3.7% of entries in watch_time_min → Suggested: mean or median fill",
    status: "warning",
  },
  {
    message: "Outliers: Drop-off rates >90% for 1.4% of content — Suggest: soft clipping",
    status: "warning",
  },
  {
    message:
      "NPS Feedback Aligned to Timestamps: Over 82% of NPS scores linked to valid activity windows",
    status: "success",
  },
  {
    message:
      "Sentiment Parsing Lag: 6.1% of open-text comments unstructured — NLP flagging applied",
    status: "warning",
  },
];

interface Props {
  files: File[];
}

const StatusChecklist: React.FC<Props> = (props) => {
  const { files } = props;
  const dispatch = useAppDispatch();

   const userId = jsCookie.get('user_id');

  const [open, setOpen] = useState<boolean>(true);

  const [loading, setLoading] = useState<boolean>(true);

  const [analyziedChecklist,setAnalyzedChecklist] = useState<any>(null)

  const uploadFile = async () => {
    setLoading(true);
    try {
      const response = await dispatch(anaylzeChatBotChecklist({ files, userId: userId||"" })).unwrap();
setAnalyzedChecklist(response.data)
    
    } catch (err) {
      console.error("Unexpected error during upload:", err);
    } finally {
      setLoading(false);
    }
  };

   useEffect(() => {
      if (files.length > 0) {
        uploadFile();
      }
    }, [files, dispatch]);

  return (
    <div
      className={`h-screen  rounded-lg w-full overflow-auto pn_scroller transition-all duration-300 ease-in-out ${
        open
          ? "flex-[0_0_100%] sm:flex-[0_0_75%] lg:flex-[0_0_460px] max-w-full lg:max-w-[460px]"
          : "flex-[0_0_100%] sm:flex-[0_0_215px] max-w-full sm:max-w-[215px]"
      }`}
    >
      <div className={`flex flex-col h-full  bg-opacity-50`}>
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <h2 className="text-lg font-semibold"> {analyziedChecklist?.title}</h2>
          </div>
          <button
            onClick={() => setOpen(!open)}
            className="cursor-pointer rounded border border-[#DFE3E8] p-1 hover:bg-gray-100"
            aria-label="Toggle Panel"
          >
            <img src={SwitchIcon} alt="Toggle" className="w-3 h-3 object-contain" />
          </button>
        </div>
        {loading ? (
                  <div className="flex-1 flex items-center justify-center text-sm text-gray-500 animate-pulse">
                    <DotLoader />
                  </div>
                ) : 
                <>
        <div className="mb-4">
          <div className="text-sm">
           {analyziedChecklist?.summary}
          </div>
        </div>
        <div className="space-y-[12px]">
          {analyziedChecklist?.findings?.map((item:any, index:number) => (
            <div
              key={index}
              className={`flex items-start gap-2 p-2 rounded-md border border-[#D7D7D7] ${
                item.type === "success" ? " text-[#358500]" : ""
              }`}
            >
              {/* <div className="my-auto">
                {item.type === "success" ? (
                  <CheckCheckIcon className="text-[#358500] w-2 h-2" />
                ) : (
                  <AlertTriangleIcon className="text-[#FFC220] w-2 h-2" />
                )}
              </div> */}
              <p className="text-sm text-gray-800">{item.text}</p>
            </div>
          ))}
        </div>
        </>
}
      </div>
    </div>
  );
};

export default StatusChecklist;
